// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1398":"7111a602218023a5","2245":"fe2121881e514bfc","6564":"13a876572bbe6dca"}[chunkId] + ".css";
};